<template>
    <div id="container" :class="['main-container', style, !showBtm ? 'nav_close' : '']" v-show="!isDetail">
        <div class="container_inner">
            <RealtimeTab />
            <RealtimeSimpleMap />
            <Biz />
            <Indicator />

            <!-- <News /> -->

            <Read />

            <!--sc06//start-->
            <!-- <div class="sc06">
                <div class="data-sgC mt-10">
                    <a :href="$_WC.cp + 'intro'">
                        <div class="sgC smartroom_bnr">
                            <p class="tit">데이터 플랫폼 소개</p>
                            <p class="txt1">모든 행정데이터 한눈에 '스마트강남 구청장실'</p>
                            <p class="txt2">‘꿈이 모이는 도시, 미래를 그리는 강남’ 온택트 리더 강남구는 구민에게 모든 행정데이터를 <br> 한눈에 볼 수 있는 스마트 강남 구청장실을 소개합니다. </p>
                        </div>
                    </a>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import RealtimeTab from '@/views/main/RealtimeTab.vue';
import RealtimeSimpleMap from '@/views/main/RealtimeSimpleMap.vue';
import Biz from '@/views/main/Biz.vue';
import Indicator from '@/views/main/Indicator.vue';
import IndicatorDetail from '@/views/indicator/IndicatorDetail.vue';
import News from '@/views/main/News.vue';
import Read from '@/views/main/Read.vue';
import {$_TYPE} from '@/confs/common.const.js';
import {mapGetters} from "vuex";

export default {
    name: 'Main',
    components: {
        RealtimeTab,
        RealtimeSimpleMap,
        Biz,
        Indicator,
        News,
        Read,
        IndicatorDetail,
    },
    data(){
        return {
            style: 'bg14',
        }
    },
    computed: {
        ...mapGetters({
            isDetail: 'getIsDetail',
            showBtm: 'getShowBtm',
        })
    },
    created() {
        let style = this.$route.query['style'];
        if(typeof style !== $_TYPE.UNDEF) {
            switch(style){
                case '1': this.style = 'bg11'; break;
                case '2': this.style = 'bg12'; break;
                case '3': this.style = 'bg13'; break;
                case '4': this.style = 'bg14'; break;
                case '5': this.style = 'bg15'; break;
            }
        }
    },
    methods: {
    },
};
</script>
<style>
.sc06 .btn-more {top: 28px;}
@media (min-width:769px) {
    .sc06 .btn-more {top: 20px;}
}
@media (min-width: 2737px) and (max-width: 7680px){
    .sc06 .btn-more {top: 44px;}
}
</style>
